import { createFileRoute } from '@tanstack/react-router'

import { AuthRefreshSession } from '@/features/auth/pages'
import { AuthModes } from '@/features/auth/policy'
import { useTenantOptional } from '@/shared/contexts/TenantContext'

export const Route = createFileRoute('/_event/auth/refresh-session')({
  staticData: {
    auth: {
      mode: AuthModes.BOOTSTRAP,
      requiresDigitalProductId: false
    }
  },
  component: TenantAuthRefreshSessionRoute
})

function TenantAuthRefreshSessionRoute() {
  const tenant = useTenantOptional()

  return (
    <AuthRefreshSession digitalProductId={tenant?.digitalProductId ?? undefined} />
  )
}
